import React from 'react'
import Img from '@bootstrap-styled/v4/lib/Img'
import styled from 'styled-components'

const mapImg = require('../../assets/images/map-icon.png')

const NavBarAddressDiv = styled('div')`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  align-items: center;
  img {
    margin-right: 24px;
  }
  .address {
    font-weight: 500;
  }
`

function NavBarAddress ({ clinic, ...props }) {
  return (
    <NavBarAddressDiv {...props}>
      <Img src={mapImg} width={50} height={50}/>
      <div>
        <div>Get directions to our clinic</div>
        <div className={'address'}>{clinic.address}</div>
      </div>
    </NavBarAddressDiv>
  )
}

export default NavBarAddress
